{
    "image_upload_error": "Hindi ma-upload ang larawan. Subukang i-reload ang pahinang ito at pumili muli ng larawan.",
    "search_placeholder": "Maghanap ng mga larawan at ilustrasyon",
    "search": "Hanapin",
    "photo": "Imahe",
    "image_by": "ni",
    "free_photos_from": "Libreng stock na mga larawan mula sa",
    "uploading": "Nag-a-upload",
    "cancel": "Kanselahin",
    "select": "Pumili"
}
